<template>
    <v-text-field
        ref="field"
        class="pad-lot-field"
        box single-line hide-details
        v-model.number="data"
        type="number"
        :label="label"
        @blur="validate({ key: 'Blur' })"
        @focus="focus"
        @keypress="validate($event)" />
</template>

<script>
export default {
    name: 'pad-lot-field',
    props: {
        value: {},
        type: { type: String },
        item: { type: Object },
        label: { type: String }
    },
    computed: {
        data: {
            get() {
                if (this.item.done && !this.value) {
                    return '0'
                }
                return String(this.value || '')
            },
            set(v) {
                this.$emit('input', this.value === '' ? null : Number(v))
            }
        }
    },
    methods: {
        validate(ev) {
            if (['+', '-', 'Enter', 'Tab', 'Blur'].indexOf(ev.key) === -1) {
                return
            }
            this.$emit('validate', {
                action: ev.key === 'Blur' ? 'blur' : (ev.key === '-' ? 'prev' : 'next'),
                type: this.type,
                item: this.item,
                value: this.value
            })
        },
        focus() {
            this.$refs.field.focus()
            this.$nextTick(() => this.$refs.field.$refs.input.select())
        },
        blur() {
            this.$refs.field.blur()
        }
    }
}
</script>

<style lang="stylus">
.pad-lot-field input
    font-size: 26px;

.pad-lot-field .v-input__slot:before
    border-color: transparent !important;

</style>
